// import { MenuItem } from "@models/MenuItem.model";
import styles from "./MenuItems.module.scss";
import { MenuItemRecord } from "@pbmodels/*";

export default function FoodMenuItem({ item }: { item: MenuItemRecord }) {
  const { name, desc, price }: MenuItemRecord = item;
  return (
    <li className={styles.foodItem}>
      <strong>{name}</strong>
      <p>
        <span>{desc}</span>
        <span>${price}</span>
      </p>
    </li>
  );
}
